import { useState } from 'react';

export function CreditsMenu() {
    const [visible, setVisible] = useState(false);

    return (
        <>
            <button id="credits-toggle" onClick={() => setVisible((v) => !v)}>ℹ</button>
            {visible && (
                <div id="credits-menu">
                    <h3>Credits and Attribution</h3>
                    <section className="credits-section">
                        <div className="credits-row">
                            <span className="credits-label">Version</span>
                            <code id="credits-version" className="credits-value">{__COMMIT_HASH__}</code>
                        </div>
                    </section>
                    <section className="credits-section">
                        <div className="credits-label">Countries and City Data</div>
                        <a
                            href="https://www.naturalearthdata.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="credits-link"
                        >
                            Natural Earth
                        </a>
                        <p className="credits-note">
                            Made with Natural Earth. Free vector and raster map data @ naturalearthdata.com.
                        </p>
                    </section>
                    <section className="credits-section">
                        <div className="credits-label">Libraries Used</div>
                        <a
                            href="https://react.dev/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="credits-link"
                        >
                            React
                        </a>
                        <a
                            href="https://threejs.org/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="credits-link"
                        >
                            Three.js
                        </a>
                        <a
                            href="https://github.com/pmndrs/react-three-fiber"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="credits-link"
                        >
                            React Three Fiber
                        </a>
                    </section>
                    <section className="credits-section">
                        <div className="credits-label">Made by</div>
                        <div className="credits-name">Zach Whitelaw</div>
                    </section>
                </div>
            )}
        </>
    );
}
